// extracted by mini-css-extract-plugin
export default {"colors":"\"~web/react/components/common/styles/colors.module.css\"","color-white":"#FFFFFF","colorWhite":"#FFFFFF","wrapper":"HVHgA","adContainer":"thtZD"};